import { MatDialogRef } from '@angular/material/dialog';
var ConfirmDialogComponent = /** @class */ (function () {
    function ConfirmDialogComponent(data, matDialogRef) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.checked = false;
        this.title = this.data.title;
        this.message = this.data.message;
        this.okText = this.data.okText;
        this.cancelText = this.data.cancelText;
        this.inputLabel = this.data.inputLabel;
        this.inputRequired = this.data.inputRequired;
        this.checkboxMessage = this.data.checkboxMessage;
    }
    ConfirmDialogComponent.prototype.confirm = function () {
        this.matDialogRef.close({
            confirmed: true,
            message: this.inputValue,
            checked: this.checked
        });
    };
    ConfirmDialogComponent.prototype.cancel = function () {
        this.matDialogRef.close({
            confirmed: false,
            message: this.inputValue,
            checked: this.checked
        });
    };
    return ConfirmDialogComponent;
}());
export { ConfirmDialogComponent };
